import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

/**
 * Estado compartilhado do drawer de notificação (cross-type). Substitui o drawer state risk-específico:
 * guarda qual tipo está ativo + seu payload (opaco; o `Drawer` do tipo faz o cast). Os bits de sessão
 * específicos de cada tipo (ex.: dismissal por bucket do risco) moram no slice do próprio tipo.
 *
 * O card/toast chamam `openDrawer(type, payload)` com conteúdo imediato; o deep link resolve o payload
 * por id e chama o mesmo `openDrawer`. `closeDrawer` só baixa a flag (mantém type/payload) pra o conteúdo
 * sobreviver à animação de fechamento.
 */
interface NotificationDrawerState {
  activeType: string | null;
  activePayload: unknown;
  isDrawerOpen: boolean;
  openDrawer: (type: string, payload: unknown) => void;
  closeDrawer: () => void;
  reset: () => void;
}

const initialState = { activeType: null, activePayload: null, isDrawerOpen: false } as const;

const useNotificationDrawerStore = create<NotificationDrawerState, [['zustand/devtools', never]]>(
  devtools(
    (set) => ({
      ...initialState,
      openDrawer: (type, payload) => set({ activeType: type, activePayload: payload, isDrawerOpen: true }, false, 'openDrawer'),
      closeDrawer: () => set({ isDrawerOpen: false }, false, 'closeDrawer'),
      reset: () => set({ ...initialState }, false, 'reset'),
    }),
    { name: 'useNotificationDrawerStore' }
  )
);

export default useNotificationDrawerStore;
